// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1ggDf","ranges":"BmiRanges_ranges__16ycV"};